import { render, staticRenderFns } from "./tzproduct3.vue?vue&type=template&id=70695e3c&scoped=true"
import script from "./tzproduct3.vue?vue&type=script&lang=js"
export * from "./tzproduct3.vue?vue&type=script&lang=js"
import style0 from "./tzproduct3.vue?vue&type=style&index=0&id=70695e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70695e3c",
  null
  
)

export default component.exports